export default __webpack_public_path__ + "static/media/sad-face-emoji.d31daffc.svg";